module.exports = __webpack_public_path__ + "img/supplier-004.0a66fc3b.png";